/**
 * Dark Mode
 *
 * Same category as Dark Reader and detected the same way, but via injected stylesheet
 * ids rather than element attributes. It adds five <link>/<style> nodes to <head> with
 * fixed ids.
 * Observed on version 0.5.6.
 */
import { probeSelector } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'dmghijelimhndkbmpgbldicpogfkceaj';
export const darkModeExt: ExtensionDefinition = {
  id: ID,
  name: 'Dark Mode',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1_000_000,
  notes:
    'Distinguishable from Dark Reader despite doing the same job, because the two use ' +
    'different marker names — the ids here are dark-mode-*, not data-darkreader-*.',
  signals: [
    { id: 'dom-injected-sheets', kind: 'dom',
      description: 'Look for #dark-mode-native-style / #dark-mode-custom-link, the stylesheets it injects into <head>.',
      weight: 1, run: () => probeSelector('#dark-mode-native-style, #dark-mode-custom-style, #dark-mode-general-link, #dark-mode-custom-link', { timeoutMs: 1500 }) },
  ],
};
